import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DemoUiService } from '../../core/demo-ui.service';
import { SECTION_COMPONENTS } from '../../shared/compound/section.components';
import { VisitContext } from './visit.context';
import { VisitPhoneComponent } from './visit-phone.component';
@Component({ selector: 'rv-visits', standalone: true, providers: [VisitContext], imports: [...SECTION_COMPONENTS, VisitPhoneComponent], templateUrl: './visits.component.html', changeDetection: ChangeDetectionStrategy.OnPush })
export class VisitsComponent { readonly ui = inject(DemoUiService); readonly visit = inject(VisitContext); }
